// Redux/constants/departmentConstants.js
export const DEPARTMENT_REQUEST = "DEPARTMENT_REQUEST";
export const DEPARTMENT_SUCCESS = "DEPARTMENT_SUCCESS";
export const DEPARTMENT_FAIL = "DEPARTMENT_FAIL";

export const DEPARTMENT_ADD_REQUEST = "DEPARTMENT_ADD_REQUEST";
export const DEPARTMENT_ADD_SUCCESS = "DEPARTMENT_ADD_SUCCESS";
export const DEPARTMENT_ADD_FAIL = "DEPARTMENT_ADD_FAIL";
export const DEPARTMENT_ADD_RESET = "DEPARTMENT_ADD_RESET";

export const DEPARTMENT_DELETE_REQUEST = "DEPARTMENT_DELETE_REQUEST";
export const DEPARTMENT_DELETE_SUCCESS = "DEPARTMENT_DELETE_SUCCESS";
export const DEPARTMENT_DELETE_FAIL = "DEPARTMENT_DELETE_FAIL";
export const DEPARTMENT_DELETE_RESET = "DEPARTMENT_DELETE_RESET";
